import type { ButtonProps, TextProps } from '@chakra-ui/react';

/** Reliable single-line ellipsis inside flex/grid (prefer over noOfLines in flex rows). */
export const singleLineEllipsisTextProps: TextProps = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  minW: 0,
};

/** Full-width league row button — ellipsis on inner text, not on the button shell. */
export const leagueRowButtonProps: ButtonProps = {
  width: 'full',
  minW: 0,
  size: 'sm',
  justifyContent: 'flex-start',
};
